import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";

function Cyclecount_BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid ">
      {vPathName === "/cyclecount" ? (
        <div>
          <span className="breadcrumb-not-active ">Cyclecount </span>
        </div>
      ) : vPathName === "/cyclecountDetail" ? (
        <div className={"d-flex align-items-center"}>
          <Link
            to="/cyclecount"
            state={location}
            className={"breadcrumb-active mr-2"}
          >
            CycleCount
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span className="breadcrumb-not-active">
            CyclecCuntDetail{" "}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default Cyclecount_BreadCrumbs;
